import { PreguntaDTO } from "@DTOS";
import { PreguntasTipoEnum } from "@shared/enums";
import { Exporter } from "../Exporter";

export class ExporterMultiple implements Exporter {
    public puedeExportar(pregunta: PreguntaDTO): boolean {
        return pregunta.tipo === PreguntasTipoEnum.MULTIPLE_CHOICE;
    }

    public exportar(respuestas: any, respuesta: any[], pregunta: PreguntaDTO): void {
        const item = pregunta.items.find(itemDTO => itemDTO.id === respuesta[0]);

        if (item == null) {
            return;
        }

        if (respuestas[pregunta.texto]) {
            respuestas[pregunta.texto] += `, ${item.texto}`;
            return;
        }

        respuestas[pregunta.texto] = item.texto;
    }
}
